/* eslint-disable boundaries/element-types */

import { CourseAuthActionsProvider } from '@hendrx/core/courses';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useDeviceView } from 'shared/utils/useDeviceView';

export const Route = createFileRoute('/studio/courses')({
  component: CoursesLayout
});

function CoursesLayout() {
  const { htmlFontSize } = useDeviceView();

  useEffect(() => {
    document.documentElement.style.setProperty('--html-font-size', `${htmlFontSize}px`);
  }, [htmlFontSize]);

  return (
    <div style={{ height: '100%' }}>
      <CourseAuthActionsProvider>
        <Outlet />
      </CourseAuthActionsProvider>
    </div>
  );
}
